module.exports = __webpack_public_path__ + "static/img/icon_yanjiuzu.2555137c.png";